import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hotels-search-card hoverShadow"
}
const _hoisted_2 = { class: "hotels-search-card-info" }
const _hoisted_3 = { class: "hotels-search-card-info-header" }
const _hoisted_4 = {
  key: 0,
  class: "hotels-search-card-info-header__stars-container"
}
const _hoisted_5 = { class: "hotels-search-card-info-header__title" }
const _hoisted_6 = { class: "hotels-search-card-info-header__services" }
const _hoisted_7 = /*#__PURE__*/_createVNode("li", { class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--ice" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--knife"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("li", { class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--news" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("li", { class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--wash" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--internet"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("li", { class: "hotels-search-card-info-header__services-item hotels-search-card-info-header__services-item--bed" }, null, -1)
const _hoisted_13 = { class: "hotels-search-card-info-main" }
const _hoisted_14 = { class: "hotels-search-card-info-main-time" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Заезд", -1)
const _hoisted_16 = { class: "hotels-search-card-info-main-time__date-wrapper" }
const _hoisted_17 = { class: "hotels-search-card-info-main-time__date" }
const _hoisted_18 = { class: "hotels-search-card-info-main-time__day" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "hotels-search-card-info-main-time__time" }, "14:00", -1)
const _hoisted_20 = { class: "hotels-search-card-info-main-time" }
const _hoisted_21 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Выезд", -1)
const _hoisted_22 = { class: "hotels-search-card-info-main-time__date-wrapper" }
const _hoisted_23 = { class: "hotels-search-card-info-main-time__date" }
const _hoisted_24 = { class: "hotels-search-card-info-main-time__day" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "hotels-search-card-info-main-time__time" }, "12:00", -1)
const _hoisted_26 = { class: "hotels-search-card-info-main-address" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h4", { class: "hotels-search-card-info-main-time__title" }, "Информация", -1)
const _hoisted_28 = { class: "hotels-search-card-info-main-address__text" }
const _hoisted_29 = { class: "hotels-search-card__image-wrapper" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "hotels-search-card__status" }, "Срочный заказ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_card_footer = _resolveComponent("search-card-footer")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            (_ctx.item.stars >= 1)
              ? (_openBlock(), _createBlock("ul", _hoisted_4, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.stars, (star) => {
                    return (_openBlock(), _createBlock("li", {
                      class: "hotels-search-card-info-header__stars-icon",
                      key: star.index
                    }))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("", true),
            _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.item.hotelName.bs.rus), 1),
            _createVNode("ul", _hoisted_6, [
              _hoisted_7,
              (_ctx.item.mealIncludedInPrice)
                ? (_openBlock(), _createBlock("li", _hoisted_8))
                : _createCommentVNode("", true),
              _hoisted_9,
              _hoisted_10,
              (_ctx.item.hasInternet)
                ? (_openBlock(), _createBlock("li", _hoisted_11))
                : _createCommentVNode("", true),
              _hoisted_12
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("div", _hoisted_16, [
                _createVNode("h4", _hoisted_17, _toDisplayString(_ctx.parseDate(_ctx.item.accessors[0].checkin, "DD MMM")), 1),
                _createVNode("span", _hoisted_18, _toDisplayString(_ctx.parseDate(_ctx.item.accessors[0].checkin, "dddd")), 1)
              ]),
              _hoisted_19
            ]),
            _createVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("div", _hoisted_22, [
                _createVNode("h4", _hoisted_23, _toDisplayString(_ctx.parseDate(_ctx.item.accessors[0].checkout, "DD MMM")), 1),
                _createVNode("span", _hoisted_24, _toDisplayString(_ctx.parseDate(_ctx.item.accessors[0].checkout, "dddd")), 1)
              ]),
              _hoisted_25
            ]),
            _createVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode("p", _hoisted_28, _toDisplayString(_ctx.item.address.bs.rus), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("img", {
            src: _ctx.item.thumbnailUrl,
            alt: "hotel-image",
            class: "hotels-search-card__image"
          }, null, 8, ["src"]),
          _hoisted_30
        ]),
        _createVNode(_component_search_card_footer, {
          toggleDisplay: _ctx.openModalPrice,
          item: _ctx.item,
          isSelected: _ctx.isSelected
        }, null, 8, ["toggleDisplay", "item", "isSelected"])
      ]))
    : _createCommentVNode("", true)
}